import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { API, formatApiErrorDetail } from "@/auth";

const today = () => new Date().toISOString().slice(0, 10);

export default function ResultEditor() {
  const [params] = useSearchParams();
  const editId = params.get("id");
  const [form, setForm] = useState({ date: today(), first_round: "", second_round: "" });
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(!!editId);
  const nav = useNavigate();

  useEffect(() => {
    document.title = "Manage Result | Admin";
    if (!editId) return;
    axios
      .get(`${API}/admin/results/${editId}`, { withCredentials: true })
      .then((r) => {
        setForm({
          date: r.data.date,
          first_round: r.data.first_round || "",
          second_round: r.data.second_round || "",
        });
      })
      .catch(() => toast.error("Failed to load result"))
      .finally(() => setLoading(false));
  }, [editId]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editId) {
        await axios.put(`${API}/admin/results/${editId}`, form, { withCredentials: true });
        toast.success("Result updated");
      } else {
        await axios.post(`${API}/admin/results`, form, { withCredentials: true });
        toast.success("Result saved");
      }
      nav("/admin/previous-results");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="ap-card">Loading…</div>;

  return (
    <div className="ap-card" data-testid="admin-result-page">
      <form onSubmit={submit} className="ap-form">
        <label className="ap-field">
          <span>Date:</span>
          <Input
            data-testid="result-date-input"
            type="date"
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
            required
          />
        </label>

        <label className="ap-field">
          <span>F/R (10:40 AM) :</span>
          <Input
            data-testid="result-first-round"
            value={form.first_round}
            onChange={(e) => setForm({ ...form, first_round: e.target.value })}
          />
        </label>

        <div className="ap-form-inline">
          <button className="ap-btn ap-btn-primary" data-testid="result-submit" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Submit"}
          </button>
          <button
            type="button"
            className="ap-btn ap-btn-secondary"
            data-testid="result-back"
            onClick={() => nav("/admin/previous-results")}
          >
            Back
          </button>
        </div>

        <label className="ap-field">
          <span>S/R (11:40 AM):</span>
          <Input
            data-testid="result-second-round"
            value={form.second_round}
            onChange={(e) => setForm({ ...form, second_round: e.target.value })}
          />
        </label>
      </form>
    </div>
  );
}
